// ─── «ИНФО О КЛИЕНТЕ»: ЧИСЛО «ИСТОРИЯ N» И КЛЮЧИ ДОСЬЕ (27.10, аудит) ───────────
// Чистые функции карточки (ClientInfoCard.tsx, ClientDossier.tsx) — проверяются node-тестом без React.
import type { ClientProfile, DossierMate } from "../../hooks/useClientProfile";

/** «История N» — все записи ленты из API (history_total: свои брони, лиды, отмены + игры в чужих командах),
 *  а не число подгруженных строк (лента — свежие 40 своих и 20 в чужих командах). Старый API без поля — по ленте. */
export function historyCount(profile: Pick<ClientProfile, "history_total"> | null | undefined, shown: number): number {
  return Math.max(Number(profile?.history_total ?? 0) || 0, shown);
}

/** React-ключ человека досье: вне смены telegram_id вычищен (stripContacts → null) — тогда по позиции, без дублей null. */
export const mateKey = (m: Pick<DossierMate, "telegram_id">, i: number): string => (m.telegram_id != null ? `tg${m.telegram_id}` : `n${i}`);
